import { Question } from "../Question/Question";
import { OnSelectQuestionProps } from "../QuestionDetailModalRoot/QuestionDetailModalRoot";
import classNames from "classnames/bind";
import styles from "./RelatedQuestions.module.css";

const cx = classNames.bind(styles);

export function RelatedQuestions({
  relatedQuestions,
  onSelectQuestion,
}: {
  relatedQuestions: {
    uuid: string;
    question: string;
    name?: string; // needed for analytics as unique identifier
    topics: string[];
    href: string;
  }[];
  onSelectQuestion: ({
    questionUuid,
    questionName,
    questionTopic,
  }: OnSelectQuestionProps) => void;
}) {
  return (
    <div className={cx("container")}>
      {relatedQuestions.slice(0, 3).map((question) => (
        <Question
          key={question.uuid}
          question={question.question}
          tags={question.topics}
          href={question.href}
          onClick={() => {
            onSelectQuestion({
              questionUuid: question.uuid,
              questionName: question.name ?? "",
              questionTopic: question.topics.join(", "),
            });
          }}
        />
      ))}
    </div>
  );
}
